import { useState } from 'react';
import { DiscountsPageContent } from './DiscountsPageContent';

export const DiscountsPage = () => {
  // keep the state in higher level component so doest rerender on data refetching
  const [editDialogIsOpen, setEditDialogIsOpen] = useState(false);

  return <DiscountsPageContent editDialogIsOpen={editDialogIsOpen} setEditDialogIsOpen={setEditDialogIsOpen} />;
};
